var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarSettingsSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z",
    stroke: "#61A333",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83313 11.8067V10.1933C1.83313 9.23999 2.6123 8.45166 3.5748 8.45166C5.23396 8.45166 5.9123 7.27832 5.07813 5.83916C4.60146 5.01416 4.88563 3.94166 5.7198 3.46499L7.30563 2.55749C8.0298 2.12666 8.9648 2.38332 9.39563 3.10749L9.49646 3.28166C10.3215 4.72082 11.6781 4.72082 12.5123 3.28166L12.6131 3.10749C13.044 2.38332 13.979 2.12666 14.7031 2.55749L16.289 3.46499C17.1231 3.94166 17.4073 5.01416 16.9306 5.83916C16.0965 7.27832 16.7748 8.45166 18.434 8.45166C19.3873 8.45166 20.1756 9.23082 20.1756 10.1933V11.8067C20.1756 12.76 19.3965 13.5483 18.434 13.5483C16.7748 13.5483 16.0965 14.7217 16.9306 16.1608C17.4073 16.995 17.1231 18.0583 16.289 18.535L14.7031 19.4425C13.979 19.8733 13.044 19.6167 12.6131 18.8925L12.5123 18.7183C11.6873 17.2792 10.3306 17.2792 9.49646 18.7183L9.39563 18.8925C8.9648 19.6167 8.0298 19.8733 7.30563 19.4425L5.7198 18.535C4.88563 18.0583 4.60146 16.9858 5.07813 16.1608C5.9123 14.7217 5.23396 13.5483 3.5748 13.5483C2.6123 13.5483 1.83313 12.76 1.83313 11.8067Z",
    stroke: "#61A333",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarSettingsSecondary);
export default __webpack_public_path__ + "static/media/side-bar-settings-secondary.44b0cef31b71cb9cd1226703b860b3ec.svg";
export { ForwardRef as ReactComponent };